export default __webpack_public_path__ + "static/media/alarm-clock.4ac80101.woff";